import { FC } from "react"
import { Box, Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import {
    useTranslate,
    useQuery,
    Loading,
    Error,
    ListProps
} from "react-admin"
import Circle from '../components/Circle'
import Grey from '@material-ui/core/colors/grey';
import { formatMoney, formatPercentage, formatDate } from "../utils/formatters";

const useStyles = makeStyles(theme => ({
    root: {
        paddingLeft: '1rem',
        paddingRight: '1rem',
        position: 'sticky',
        // width: '100%',
        top: '5rem',
    },
    circleText: {
    },
    card: {
        marginBottom: '1rem',
    },
    cardTitle: {
        marginTop: '1rem',
        marginBottom: '0.5rem',
    },
    mainCard: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    firstDescription: {
        flexGrow: 1,
        paddingLeft: '1rem',
        paddingRight: '1rem',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    label: {
        // color: theme.palette.primary.main
        display: 'flex',
        flexDirection: 'column'
    },
    labelValue: {
        color: '#000',
        fontWeight: 'bold',
    },
    labelText: {
        color: Grey[500],
    },
    row: {
        display: 'flex'
    },
    rowText: {
        color: Grey[500],
        flexGrow: 1,
    },
    rowValue: {
        color: '#000',
        // fontWeight: 'medium',
    },
    descCard: {
    },
}))

interface MerchantDashboardAsideProps extends ListProps {
    merchant: any
}

const MerchantDashboardAside: FC<MerchantDashboardAsideProps> = ({ merchant }) => {
    const classes = useStyles()
    const translate = useTranslate()

    const { data: user, loading, error } = useQuery({
        type: 'getOne',
        resource: 'users',
        payload: {} as any
    })

    if (loading) return <Loading />;
    if (error) return <Error error={error} />;
    // if (!user) return null;

    // if (!merchant) return null
    const financing = merchant?.Financings[0]
    // console.log(financing)
    // console.log(financing, financing.financing_date.toLocaleDateString())

    const financialRegimen = merchant?.FinancialRegimen
    const fixedFee = financing?.fixed_fee / 10000 || 0
    const loanAmount = financing?.amount || 0
    const repaymentRate = financing?.repayment_rate / 10000 || 0;
    const vatPercent = (financialRegimen?.data as any)?.VAT?.value || 0 //TODO: impement JSONB type
    const repaidAmount = financing?.Transactions_aggregate?.aggregate?.sum?.value || 0
    const vatAmount = loanAmount * fixedFee * vatPercent
    const totalFinancing = loanAmount * fixedFee * (1 + vatPercent) + loanAmount

    // console.log(loanAmount, repaidAmount)

    return <Box order={-1} className={classes.root}>
        <Box>
            <Typography variant="h4">{merchant?.name || '--'}</Typography>
            <Typography variant="subtitle1">{user?.display_name || '--'}</Typography>
        </Box>
        <Typography variant="h5" component="h2" className={classes.cardTitle}>{translate('resources.Merchant.dashboard.balanceTitle')}</Typography>
        <Card className={classes.card}>
            <CardContent className={classes.mainCard}>
                <Circle percent={repaidAmount / totalFinancing} />
                <Box className={classes.firstDescription}>
                    <div className={classes.label}>
                        <Typography className={classes.labelValue} variant="subtitle1">{formatMoney(repaidAmount)}</Typography>
                        <Typography className={classes.labelText} variant="caption">{translate('resources.Merchant.dashboard.liquidated')}</Typography>
                    </div>
                    <div className={classes.label}>
                        <Typography className={classes.labelValue} variant="subtitle1">{formatMoney(totalFinancing - repaidAmount)}</Typography>
                        <Typography className={classes.labelText} variant="caption">{translate('resources.Merchant.dashboard.balance')}</Typography>
                    </div>
                </Box>
                {/* </Circle> */}
            </CardContent>
        </Card>
        <Typography variant="h5" component="h2" className={classes.cardTitle}>{translate('resources.Merchant.dashboard.detailTitle')}</Typography>
        <Card className={classes.card}>
            <CardContent className={classes.descCard}>
                <div className={classes.row}>
                    <Typography className={classes.rowText} variant="body1">{translate('resources.Merchant.dashboard.financing_id')}</Typography>
                    <Typography className={classes.rowValue} variant="subtitle1">{financing?.id || 0}</Typography>
                </div>
                <div className={classes.row}>
                    <Typography className={classes.rowText} variant="body1">{translate('resources.Merchant.dashboard.financing_date')}</Typography>
                    <Typography className={classes.rowValue} variant="subtitle1">{formatDate(financing?.financing_date)}</Typography>
                </div>
                <div className={classes.row}>
                    <Typography className={classes.rowText} variant="body1">{translate('resources.Merchant.dashboard.limit_date')}</Typography>
                    <Typography className={classes.rowValue} variant="subtitle1">{formatDate(financing?.limit_date)}</Typography>
                </div>
            </CardContent>
        </Card>
        <Card className={classes.card}>
            <CardContent className={classes.descCard}>
                <div className={classes.row}>
                    <Typography className={classes.rowText} variant="body1">{translate('resources.Merchant.dashboard.capital_received')}</Typography>
                    <Typography className={classes.rowValue} variant="subtitle1">{formatMoney(loanAmount)}</Typography>
                </div>
                <div className={classes.row}>
                    <Typography className={classes.rowText} variant="body1">{translate('resources.Merchant.dashboard.cost')}</Typography>
                    <Typography className={classes.rowValue} variant="subtitle1">{formatMoney(loanAmount * fixedFee)}</Typography>
                </div>
                {vatAmount > 0 && <div className={classes.row}>
                    <Typography className={classes.rowText} variant="body1">{translate('resources.Merchant.dashboard.vat_total')}</Typography>
                    <Typography className={classes.rowValue} variant="subtitle1">{formatMoney(vatAmount)}</Typography>
                </div>}
                <div className={classes.row}>
                    <Typography className={classes.rowText} variant="body1">{translate(vatAmount > 0 ? 'resources.Merchant.dashboard.liquidated_total_vat' : 'resources.Merchant.dashboard.liquidated_total')}</Typography>
                    <Typography className={classes.rowValue} variant="subtitle1">{formatMoney(totalFinancing)}</Typography>
                </div>
            </CardContent>
        </Card>
        <Card className={classes.card}>
            <CardContent className={classes.descCard}>
                <div className={classes.row}>
                    <Typography className={classes.rowText} variant="body1">{translate('resources.Merchant.dashboard.sales_percentage')}</Typography>
                    <Typography className={classes.rowValue} variant="subtitle1">{formatPercentage(repaymentRate)}</Typography>
                </div>
            </CardContent>
        </Card>
    </Box >
}


export default MerchantDashboardAside